export interface PowerBiReport {
    id: string;
    displayName: string;
    reportId: string;
    tenantId: string;
    category: string;
    isPaginated: boolean;
    isActive: boolean;
}

export class PowerBiReportParameters {
    rpName: string;
    rpValue: string;
  }
